import copy from 'copy-to-clipboard';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useSearchParams } from 'react-router-dom';

import CustomDropdown from '../../../../components/DropDown';
import Loader from '../../../../components/Loader';
import { DOC_BASE_URL } from '../../../../util/constant';
import useDocument from '../useDocument';

const Document: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    loading,
    documentData,
    onchangeView,
    viewDocument,
    tags,
    selectedTag,
    setSelectedTag,
    handleDateFilter,
    setViewDocument,
    viewVideo,
    setViewVideo,
  } = useDocument();

  const handleTagChange = (tagId: string) => {
    setSelectedTag(tagId);
    handleDateFilter();
  };
  console.log("viewVideo", viewVideo);
  const formattedTags = [
    { id: "", name: "All" },
    ...tags.map((tag: any) => ({
      id: tag.tag,
      name: tag.tag,
    })),
  ];

  // Handle document selection from URL
  useEffect(() => {
    const docTitle = searchParams.get("doc");
    if (docTitle) {
      const document = documentData.find((doc) => doc.link === docTitle);
      if (document) {
        setViewDocument(document.link);
        if (document.video) {
          setViewVideo(document.video);
        }
      }
    }
  }, [searchParams, documentData]);

  // Update URL when document is selected
  const handleDocumentSelect = (title: string) => {
    const document = documentData.find((doc) => doc.link === title);
    if (document) {
      setViewDocument(document.link);
      if (document.video) {
        setViewVideo(document.video);
      } else {
        setViewVideo(""); // Clear video if new document doesn't have one
      }
      setSearchParams({ doc: title });
    }
  };

  const handleShare = () => {
    const currentUrl = "https://task.blisslers.com/document?doc=" + viewDocument;
    console.log("Sharing URL:", currentUrl);
    copy(currentUrl);
    toast.success("Link copied to clipboard!", { duration: 3000 });
  };

  return (
   <div className="m-5 mt-0">
  {loading && <Loader />}

  {/* Header with Filter and Share */}
  <div className="mb-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
    <CustomDropdown
      label="Filter by Tag"
      options={formattedTags}
      defaultOptionId={selectedTag}
      setDefaultOptionId={handleTagChange}
      displayProperty="name"
      value={selectedTag || "All"}
      style="bg-white"
    />

    {(viewDocument || viewVideo) && (
      <button
        onClick={handleShare}
        className="px-5 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg shadow hover:bg-blue-700 transition-colors"
      >
        Share Document
      </button>
    )}
  </div>

  {/* Main Content */}
  <div className="flex flex-col lg:flex-row gap-6">
    
    {/* Sidebar: Document Titles */}
    <div className="lg:w-1/4 w-full overflow-y-auto h-[82vh] bg-white border border-gray-200 rounded-lg shadow-sm p-4 space-y-3">
      {documentData.map((document: any) => (
        <button
          key={document.title}
          onClick={() => handleDocumentSelect(document.link)}
          className={`block w-full text-left px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors ${
            searchParams.get("doc") === document.link ? "bg-blue-100" : ""
          }`}
        >
          <span className="text-sm font-medium text-gray-800 break-words">
            {document.title}
          </span>
        </button>
      ))}
    </div>

    {/* Content Viewer */}
    <div className="flex-1 h-[75vh] overflow-hidden border border-gray-200 rounded-lg shadow-sm bg-white p-4 flex flex-col gap-4">
      
      {viewVideo && (
        <div className="w-full h-auto">
          <video className="w-full max-h-[300px] rounded-md" controls>
            <source src={viewVideo} />
          </video>
        </div>
      )}

      <div className="flex-1 w-full">
        <iframe
          src={`${DOC_BASE_URL}${viewDocument}`}
          width="100%"
          height={viewVideo ? "440" : "600"}
          title="Document Viewer"
          className="w-full h-full rounded-md"
          frameBorder="0"
        ></iframe>
      </div>
    </div>
  </div>
</div>
  );
};

export default Document;
